<section>
    <div class="left-bg bg-color-primary-light d-none d-lg-block">
        <img alt="Colposcopy, Cervical cancer, AI, CareNX" src="../../../../../assets/images/products/sindicolpo/components/sindi-05.png">
    </div>
    <div class="container inner-section">
        <div class="row align-items-center">
            <div class="col-12">
                <div class="inner-block d-flex flex-lg-row flex-column justify-content-between">
                    <div class="image-container mb-5 mb-lg-0 d-flex align-items-center justify-content-center">
                        <img alt="Colposcopy, Cervical cancer, AI, CareNX" src="../../../../../assets/images/products/sindicolpo/intro/sindi-device-stitch-removebg.png">
                    </div>
                    
                    <div class="details-container d-flex flex-column align-items-center align-items-lg-start justify-content-center mb-4 mb-md-0" >
                        <h1 class="mb-5 text-lg-left text-center">
                            SindiColpo Device<br>
                            Main Components</h1>
                        <ul>
                            <li class=" mb-4">
                                <p class="font-18 ml-4">Device Holder</p>
                            </li>
                            <li class=" mb-4">
                                <p class="font-18 ml-4">Smartphone</p>
                            </li>
                            <li class=" mb-4">
                                <p class="font-18 ml-4">Handle</p>
                            </li>
                            <li class=" mb-4">
                                <p class="font-18 ml-4">Charger</p>
                            </li>
                            <li class=" mb-4">
                                <p class="font-18 ml-4">Stand</p>
                            </li>
                            <li class=" mb-4">
                                <p class="font-18 ml-4">Device Case</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>